// @flow
import _ from 'lodash'
import React, { Component } from 'react'
import styled, { type StyledComponent } from 'styled-components'
import { grayColor } from './colors'
import type { OptionType } from '../types'

const HOR_SPACE = 2
const VERT_SPACE = 3

const Wrapper: StyledComponent<Object, any, any> = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: -${VERT_SPACE}px -${HOR_SPACE}px;
`
const OptionWrapper: StyledComponent<Object, any, any> = styled.div`
  padding: ${VERT_SPACE}px ${HOR_SPACE}px;
`
const optionFunc: any = ({ isSelected, isDisabled }: any) => {
  const insensitive = isSelected || isDisabled
  const hoverColor = isDisabled ? 'initial' : '#edf4ff'
  const activeColor = isDisabled ? '#eee' : '#d2e9f8'
  const borderColor = isSelected && !isDisabled ? '#bbd9f8' : grayColor

  return {
    border: 'solid 1px',
    borderColor: borderColor,
    borderRadius: 3,
    backgroundColor: isSelected ? activeColor : 'white',
    userSelect: 'none',
    padding: '4px 8px',
    cursor: insensitive ? 'initial' : 'pointer',
    fontSize: 14,
    ':hover': {
      backgroundColor: isSelected ? activeColor : hoverColor
    }
  }
}
const Option = styled.div(optionFunc)

type Props = {|
  value: any,
  options: Array<OptionType>,
  disabled?: boolean,
  onChange?: Function
|}

export default class ExposedSelect extends Component<Props> {
  render() {
    const { value, options, disabled, onChange } = this.props

    return (
      <Wrapper>
        {_.map(options, (option) => (
          <OptionWrapper key={option.id}>
            <Option
              isSelected={option.id === value}
              isDisabled={disabled}
              onClick={() => onChange && onChange(option.id)}
            >
              {option.name}
            </Option>
          </OptionWrapper>
        ))}
      </Wrapper>
    )
  }
}
